import React from "react";
import PropTypes from "prop-types";
import { WARN_MIN } from "./estados";

const BAR_MAX_PX = 150;

const pad = (n) => (n < 10 ? `0${n}` : `${n}`);

/**
 * Eventos de geocerca recibidos por hora y latencia mediana (created_at - fecha).
 * La latencia refleja sobre todo el sondeo de 5 min a Cerberus y la cola.
 */
const HourlyChart = ({ hours }) => {
  const maxN = Math.max(1, ...hours.map((h) => h.events));

  return (
    <section className="ms-card ms-section">
      <div className="ms-section-head">
        <h2>Actualizaciones de salidas por hora</h2>
        <span>Eventos de geocerca recibidos hoy · latencia mediana debajo</span>
      </div>
      {hours.length === 0 ? (
        <div className="ms-empty">Aún no se han recibido eventos de geocerca hoy.</div>
      ) : (
        <div className="ms-scroll-x">
          <div className="ms-bars">
            {hours.map((h, i) => (
              <div className="ms-bar-col" key={h.hour}>
                <span>{h.events}</span>
                <div
                  className="ms-bar"
                  style={{
                    height: Math.round((h.events / maxN) * BAR_MAX_PX),
                    background: i === hours.length - 1 ? "#c7c7cf" : "#3d3d43",
                  }}
                ></div>
              </div>
            ))}
          </div>
          <div className="ms-bars-labels">
            {hours.map((h) => (
              <div className="ms-bar-label" key={h.hour}>
                <span>{pad(h.hour)}h</span>
                <span style={{ color: h.latency_median > WARN_MIN ? "#c4282d" : "#5c5c64" }}>
                  {h.latency_median === null ? "—" : `${h.latency_median}m`}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
      <div className="ms-legend">
        <span>
          <span className="ms-swatch" style={{ background: "#3d3d43" }}></span>Horas completas
        </span>
        <span>
          <span className="ms-swatch" style={{ background: "#c7c7cf" }}></span>Hora en curso
        </span>
        <span>
          <span className="ms-mono" style={{ color: "#c4282d", fontWeight: 700 }}>00m</span>
          Latencia mediana sobre el umbral de demora
        </span>
      </div>
    </section>
  );
};

HourlyChart.propTypes = {
  hours: PropTypes.array,
};

export default HourlyChart;
